'use client';

import { Badge, Text } from '@terra/ui-design-system';
import { Box, HStack, VStack } from '@terra/ui-styled-system';
import type { CoPilotAgentMessageToolCallDebug } from '@terra/shared-dto-chat-types';
import { formatToolCallArgs } from './agentMessageViewUtils';

type AgentToolCallCardsProps = {
  toolCalls: CoPilotAgentMessageToolCallDebug[];
};

export function AgentToolCallCards({ toolCalls }: AgentToolCallCardsProps) {
  return (
    <VStack alignItems="stretch" gap={2}>
      {toolCalls.map((toolCall, index) => {
        const argsText = formatToolCallArgs(toolCall.args);
        const key = toolCall.id ?? toolCall.name ?? `tool-call-${index}`;

        return (
          <Box
            key={key}
            borderWidth="1px"
            borderColor="border.subtle"
            borderRadius="md"
            overflow="hidden"
            bg="bg.subtle"
          >
            <HStack
              px={3}
              py={2}
              borderBottomWidth={argsText ? '1px' : undefined}
              borderColor="border.subtle"
              justifyContent="space-between"
              alignItems="center"
              gap={2}
              flexWrap="wrap"
            >
              <HStack gap={2} alignItems="center">
                <Badge variant="emphasis" size="sm">
                  tool call
                </Badge>
                <Text fontSize="sm" fontWeight="semibold" fontFamily="mono">
                  {toolCall.name ?? 'unknown'}
                </Text>
              </HStack>
              {toolCall.id && (
                <Text fontSize="2xs" color="fg.muted" fontFamily="mono">
                  {toolCall.id}
                </Text>
              )}
            </HStack>
            {argsText ? (
              <Box px={3} py={2} maxH="200px" overflow="auto">
                <Text
                  as="pre"
                  fontSize="xs"
                  fontFamily="mono"
                  whiteSpace="pre-wrap"
                  wordBreak="break-word"
                  m={0}
                  color="fg.default"
                  lineHeight="1.5"
                >
                  {argsText}
                </Text>
              </Box>
            ) : null}
          </Box>
        );
      })}
    </VStack>
  );
}
